const BASE_DOMAIN = 'xiaoman.cn'
const OKKI_DOMAIN = 'okki.com'
const OKKI_AI_DOMAIN = 'okki.ai'

const envConfigs = {
  development: {
    enterprise: `http://home.dev.${BASE_DOMAIN}`,
    me: `https://login.dev.${BASE_DOMAIN}`,
    website: `http://m.official.test.${BASE_DOMAIN}/mobile`,
    personal: `https://k.dev.${BASE_DOMAIN}/account/information`
  },
  release: {
    enterprise: `https://home.${BASE_DOMAIN}`,
    me: `https://login.${BASE_DOMAIN}`,
    website: `https://mobile.${BASE_DOMAIN}/mobile`,
    personal: `https://k.dev.${BASE_DOMAIN}/account/information`
  },
  production: {
    enterprise: `https://home.${BASE_DOMAIN}`,
    me: `https://login.${BASE_DOMAIN}`,
    website: `https://mobile.${BASE_DOMAIN}/mobile`,
    personal: `https://crm.${BASE_DOMAIN}/account/information`
  }
}

const host = envConfigs[process.env.NODE_ENV] || envConfigs.production

// 兼容在okki.com域名下访问
if (location.origin.includes('okki.com')) {
  Object.keys(host).forEach(key => {
    host[key] = host[key].replace(BASE_DOMAIN, OKKI_DOMAIN)
  })
} else if (location.origin.includes('okki.ai')) {
  Object.keys(host).forEach(key => {
    host[key] = host[key].replace(BASE_DOMAIN, OKKI_AI_DOMAIN)

    if (key === 'enterprise') {
      host[key] = host[key].replace('home', 'io') + '/home'
    } else if (key === 'personal') {
      host[key] = host[key].replace('crm', 'io')
    } else if (key === 'me') {
      host[key] = host[key].replace('login', 'io')
    }
  })
}

export default host
